<template>
  <div class="outer-wrapper" :class="[brandClass]">
    <header>
      <RouterLink :to="{ name: 'login' }">
        <img class="wordmark" :src="isLawnStarter ? lsLogo : ''" :alt="brandName" />
      </RouterLink>
    </header>
    <div class="inner-content"><RouterView /></div>
    <div v-if="isLawnStarter">
      <img
        v-if="screenSize.desktop"
        src="@/assets/guest_view/lawnstarter_hero_yard.svg"
        alt="Yard"
        class="hero-img"
      />
      <img
        v-else
        src="@/assets/guest_view/lawnstarter_hero_yard_mobile.svg"
        alt="Yard"
        class="hero-img"
      />
    </div>
  </div>
</template>

<script>
import { themedComponentMixin } from '@/mixins';
import { mapState } from 'vuex';
import LsLogo from '@/assets/lawnstarter_green.svg';

export default {
  name: 'GuestParentView',
  mixins: [themedComponentMixin],
  data() {
    return {
      lsLogo: LsLogo,
    };
  },
  computed: {
    ...mapState(['screenSize']),
    brandClass() {
      return process.env.VUE_APP_BRAND_THEME;
    },
  },
};
</script>

<style lang="scss" scoped>
.outer-wrapper {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

header {
  padding: 40px;
}

.inner-content {
  align-self: center;
  flex-shrink: 0;
  padding: 30px;
  width: 540px;
  height: 400px;
  border: 1px solid $primary;
}

.hero-img {
  width: 100%;
  transform: translateY(6px);
}

@media (max-width: $mobile-max-width) {
  header {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px 0;
  }

  .content-wrapper {
    padding-top: 30px;
  }

  .inner-content {
    padding: 20px 10px;
    border: 1px solid $primary;
    max-width: 95%;
  }
}

.themed-app {
  .wordmark {
    content: $theme-logo;
  }

  .inner-content {
    border-color: $theme-color-primary;
  }

  .lawnlove {
    background-color: $theme-color-gray-light;
    justify-content: unset;

    header {
      background-color: $theme-color-white;
      padding: 25px 30px;
    }

    .inner-content {
      background-color: $theme-color-white;
      margin-top: 40px;
    }

    @media (max-width: $mobile-max-width) {
      .inner-content {
        margin-top: 20px;
      }
    }
  }
}
</style>
